import React from 'react';
import styled from 'styled-components';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  FaChartPie,
  FaTags,
  FaBuilding,
  FaUsers,
  FaTools,
  FaCreditCard,
  FaQrcode,
  FaQuestionCircle,
  FaRobot,
  FaReceipt,
  FaMusic,
  FaSignOutAlt,
} from 'react-icons/fa';
import { useAuth } from '../../hooks/useAuth.jsx';
import { colors } from '../../utils/colors.js';
import { APP_NAME } from '../../config/api.js';

const Shell = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Sidebar = styled.aside`
  width: 240px;
  flex-shrink: 0;
  background: ${colors.gray[900]};
  color: ${colors.white};
  display: flex;
  flex-direction: column;
  padding: 20px 0;
`;

const Brand = styled.div`
  font-weight: 700;
  font-size: 16px;
  padding: 0 20px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 12px;
`;

const NavItem = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  color: ${colors.gray[300]};
  text-decoration: none;
  font-size: 14px;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
    color: ${colors.white};
  }

  &.active {
    background: ${colors.gradients.primary};
    color: ${colors.white};
  }
`;

const Footer = styled.div`
  margin-top: auto;
  padding: 12px 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const AdminName = styled.div`
  font-size: 13px;
  color: ${colors.gray[400]};
  margin-bottom: 8px;
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  color: ${colors.gray[300]};
  cursor: pointer;
  font-size: 14px;
  padding: 8px 0;

  &:hover {
    color: ${colors.white};
  }
`;

const Content = styled.main`
  flex: 1;
  padding: 32px;
  overflow-x: auto;
`;

const NAV_ITEMS = [
  { to: '/', label: 'Dashboard', icon: FaChartPie, end: true },
  { to: '/categorias', label: 'Categorias', icon: FaTags },
  { to: '/spaces', label: 'Spaces', icon: FaBuilding },
  { to: '/checkins', label: 'Checkins', icon: FaQrcode },
  { to: '/usuarios', label: 'Usuários', icon: FaUsers },
  { to: '/ferramentas', label: 'Ferramentas', icon: FaTools },
  { to: '/assinaturas', label: 'Assinaturas', icon: FaCreditCard },
  { to: '/ajuda', label: 'Ajuda', icon: FaQuestionCircle },
  { to: '/automacoes', label: 'Automações', icon: FaRobot },
  { to: '/nfce', label: 'NFCe', icon: FaReceipt },
  { to: '/cache-artistas', label: 'Cache Artistas', icon: FaMusic },
];

export default function Layout({ children }) {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Shell>
      <Sidebar>
        <Brand>{APP_NAME}</Brand>
        {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
          <NavItem key={to} to={to} end={end}>
            <Icon /> {label}
          </NavItem>
        ))}
        <Footer>
          <AdminName>{admin?.nome || admin?.email}</AdminName>
          <LogoutButton onClick={handleLogout}>
            <FaSignOutAlt /> Sair
          </LogoutButton>
        </Footer>
      </Sidebar>
      <Content>{children}</Content>
    </Shell>
  );
}
